import React, { useContext } from 'react';
import { LanguageContext } from '../App';
import { privacyContent } from '../utils/legalContent';

const pageStyle = {
  maxWidth: '800px',
  margin: '0 auto',
  padding: '20px',
  fontSize: '15px',
  lineHeight: 1.6,
};

const titleStyle = {
  fontSize: '28px',
  lineHeight: 1.2,
  margin: '0 0 12px',
  color: 'var(--color-navy)',
};

const metaStyle = {
  margin: '0 0 20px',
  color: 'var(--color-muted)',
};

const sectionStyle = {
  margin: '0 0 18px',
};

const listStyle = {
  margin: '10px 0 0 20px',
};

function Privacy() {
  const { language } = useContext(LanguageContext);
  const content = privacyContent[language] || privacyContent.en;

  return (
    <div className="page-container">
      <div className="page-content">
        <div style={pageStyle}>
          <h1 style={titleStyle}>{content.title}</h1>
          <p style={metaStyle}>
            {content.lastUpdatedLabel}: {content.lastUpdatedValue}
          </p>

          <p style={sectionStyle}>{content.intro}</p>

          {content.sections.map((section) => (
            <div key={section.heading} style={sectionStyle}>
              <p>
                <strong>{section.heading}</strong>
              </p>
              {section.paragraphs?.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
              {section.items?.length ? (
                <ul style={listStyle}>
                  {section.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Privacy;
